import Qs from 'qs';
import service from "@/utils/request";

/**
 * 通用請求函數
 * @param {string} url 請求URL
 * @param {Object} [option={}] 請求參數
 * @param {Function} [suc] 成功回調
 * @param {Function} [fail] 失敗回調
 * @param {string} [method='GET'] 請求方法
 * @param {string} [dataType] 數據類型（json/formData/x-www-form-urlencoded）
 * @param {string} [responseType] 響應類型（默認json，可選 blob/arraybuffer 等）
 * @returns {Promise} 返回axios的Promise對象
 */
export async function dataChange(
  url,
  option = {},
  suc,
  fail,
  method = 'GET',
  dataType,
  responseType
) {
  const config = {
    method: method.toUpperCase(),
    url,
    headers: {}
  };
  // 設置響應類型（如 blob）
  if (responseType) {
    config.responseType = responseType;
  }
  // 處理不同請求類型的參數
  if (config.method === 'GET') {
    config.params = option;
  } else {
    // 根據 dataType 處理 POST 數據
    switch (dataType.toLowerCase()) {
      case 'json':
        config.data = option;
        config.headers['Content-Type'] = 'application/json';
        break;
      case 'formdata':
        config.data = option;
        // config.headers['Content-Type'] = 'multipart/form-data';
        break;
      case 'form':
        config.data = Qs.stringify(option);
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        break;
      default:
        config.data = option;
      // 不聲明 Content-Type
    }
  }

  try {
    const res = await service.request(config);
    // Blob 類型處理（直接返回原始響應）
    if (responseType === 'blob' && suc && typeof suc === 'function') {
      return suc(res);
    }

    if(suc && (typeof suc == 'function')) return suc(res);
    return res;
  } catch (error) {
    // 通用錯誤處理
    const errorInfo = {
      url,
      method: config.method,
      status: error.response ? error.response.status : null,
      message: error.message,
      timestamp: new Date().toISOString()
    };

    console.error('請求錯誤:', errorInfo);

    // 可選自定義錯誤處理
    if(fail && (typeof fail == 'function')) return fail(error);
    throw error;
  }
}

// 導出預配置的axios實例（可選）
export const request = dataChange;

/**
 * ## Usage example ##
 *
 * methods: {
 *     submitForm() {
 *       const formData = {
 *         username: this.username,
 *         email: this.email
 *       };
 *
 *       dataChange(
 *         '/api/submit',
 *         formData,
 *         (res) => {
 *           this.$message.success(`提交成功！ID: ${res.data.id}`);
 *           this.resetForm();
 *         },
 *         (err) => {
 *           this.$message.error(`提交失敗: ${err.response?.data?.message || '未知錯誤'}`);
 *         },
 *         'POST',
 *         'json'
 *       );
 *     }
 *   }
 */
